import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { getHeadingColor, link } from '../../styles/jss/utils';
export const contentFeatureHeights = {
    SMALL: '400px',
    MEDIUM: '512px',
    LARGE: '804px',
};
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        // For full width image to position against
        position: 'relative',
        display: 'flex',
        // Mobile - image below content
        flexDirection: 'column-reverse',
        placeContent: 'center',
        overflow: 'hidden',
        '& video': {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            objectFit: 'cover',
        },
    },
    heading: {
        'h1&,h2&,h3&,h4&,div&': Object.assign(Object.assign({}, theme.typography.medium_bold), { marginBottom: _params.isQuotation ? 0 : spacing.small, [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.xl_bold) }),
    },
    mobileExpandedHeading: {
        [theme.breakpoints.down('sm')]: {
            'h1&,h2&,h3&,h4&,div&': {
                display: '-webkit-box',
                '-webkit-line-clamp': 2,
                '-webkit-box-orient': 'vertical',
                textOverflow: 'ellipsis',
                //maxHeight: '2.4em', // 2 lines at 1.2 line-height
            },
        },
    },
    message: {
        'p&,div&': Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_sm), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typographySpacing.small_regular_lg) }),
    },
    contentInner: {
        'h1&,h2&,h3&,h4&,div&,p&': {
            padding: spacing.large,
            margin: 'initial',
            [theme.breakpoints.up('sm')]: {
                padding: spacing.large,
            },
            [theme.breakpoints.up('md')]: {
                padding: `${spacing.large} ${spacing.xl}`,
            },
            [theme.breakpoints.up('lg')]: {
                padding: spacing.xl,
            },
            [theme.breakpoints.up('xl')]: {
                padding: spacing.xxl,
            },
        },
        '& > :last-child': {
            marginBottom: spacing.large,
            [theme.breakpoints.up('md')]: {
                marginBottom: '0px',
            },
        },
    },
    headingLine: {
        alignSelf: 'flex-start',
        marginBottom: spacing.xs,
        display: 'block',
    },
    positionBottom: {
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
    },
    positionTop: {
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
    },
    positionCenter: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    largeAdvertisingHeading: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm) }),
    standardHeading: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm) }),
    quotationTitle: {
        marginBottom: `0 !important`, // important to override the default margin
        paddingBottom: `2px !important`, // important to override the default padding
        ' > span': {
            marginBottom: 0,
        },
    },
    headingColor: {
        color: getHeadingColor(_params === null || _params === void 0 ? void 0 : _params.textColour),
    },
    ffImage: {},
    positionLeft: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row-reverse',
        },
    },
    positionRight: {
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    minHeightSmall: {
        [theme.breakpoints.up('sm')]: {
            height: contentFeatureHeights.SMALL,
        },
        '& button': {
            '& img': {
                [theme.breakpoints.up('sm')]: {
                    height: `${contentFeatureHeights.SMALL} !important`, //important to override the inline styles for img tag
                    objectFit: 'cover',
                },
            },
        },
    },
    minHeightMedium: {
        [theme.breakpoints.up('sm')]: {
            height: contentFeatureHeights.MEDIUM,
        },
        '& button': {
            '& img': {
                [theme.breakpoints.up('sm')]: {
                    height: `${contentFeatureHeights.MEDIUM} !important`, // important to override the inline styles for img tag
                    objectFit: 'cover',
                },
            },
        },
    },
    minHeightLarge: {
        [theme.breakpoints.up('sm')]: {
            height: contentFeatureHeights.LARGE,
        },
        '& button': {
            '& img': {
                [theme.breakpoints.up('sm')]: {
                    height: `${contentFeatureHeights.LARGE} !important`, // important to override the inline styles for img tag
                    objectFit: 'cover',
                },
            },
        },
    },
    thirdLink: {
        gridColumn: '1 / 3', // span across both columns
        justifySelf: 'center',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '50%',
        },
    },
    linkItem: {
        [theme.breakpoints.down('md')]: {
            paddingLeft: '0',
            width: '100%',
        },
        '& a': {
            width: '100%',
        },
        '& button': {
            height: '100%',
            width: '100%',
        },
    },
    linkGrid: {
        [theme.breakpoints.down('md')]: {
            width: '100%',
            flexDirection: 'column',
        },
    },
    textLeft: {
        [theme.breakpoints.up('md')]: {
            justifyContent: 'left',
        },
    },
    textRight: {
        [theme.breakpoints.up('md')]: {
            justifyContent: 'right',
            marginLeft: `-${spacing.small}`,
        },
    },
    textCenter: {
        [theme.breakpoints.up('md')]: {
            justifyContent: 'center',
        },
    },
    link: {
        '&:focus-visible': {
            outline: 0,
            outlineOffset: 0,
        },
        '& button .labelSmall': {
            padding: 0,
        },
    },
    quotationMessage: {
        marginBottom: _params.newStyle && _params.isShowMore ? spacing.small : `${spacing.medium} !important`, // important to override the default margin
    },
    content: {},
    image: {},
    mobileLinkGrid: {
        position: 'absolute',
        bottom: 0,
        padding: `${spacing.medium}`,
        width: '100%',
        zIndex: 2,
    },
    mobileExpandedOverlay: {
        [theme.breakpoints.down('sm')]: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            pointerEvents: 'none', // Allow interactions to pass through to content
        },
    },
    expandedContent: {
        [theme.breakpoints.down('sm')]: {
            position: 'relative',
            zIndex: 2,
            height: '100%',
            maxHeight: '100%', // Prevent expansion beyond container
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start', // Start from top to allow scrolling
            overflow: 'auto', // Allow scrolling when content overflows
        },
    },
    expandedMobileLinkGrid: {
        [theme.breakpoints.down('sm')]: {
            zIndex: 3, // Higher than overlay and content to ensure buttons are visible
            position: 'relative',
        },
    },
    linkText: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), link(colors.primary.gold4)), { color: colors.primary.gold5, [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.medium_regular) }),
}));
export default useStyles;
